function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNnIconFlagsDeDelivery = function SvgNnIconFlagsDeDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Lager 17",
    viewBox: "0 0 50.47 33.81"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "black stripe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.12.13h50.22v33.56H.12z",
    style: {
      fill: "#050807"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 33.34v33.32H25V33.34zm.25-.25H24.77v33.82h50.46V33.09Z",
    style: {
      fill: "#87888a"
    },
    transform: "translate(-24.77 -33.09)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.25 11.35h49.97v22.21H.25z",
    "data-name": "red stripe",
    style: {
      fill: "#ff0005"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.25 22.46h49.97v11.1H.25z",
    "data-name": "gold stripe",
    style: {
      fill: "#ffdc00"
    }
  }));
};
export default SvgNnIconFlagsDeDelivery;